import React from 'react'
import { useParams } from 'react-router-dom'

const StudyIdTitle = () => (<span className="navbar-header__id">{ `- ${useParams().study_id}` }</span>)

export default StudyIdTitle
